"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.payment_api = void 0;
var _lsfastapiClient = require("@lsoft/lsfastapi-client");
var openapi = {
  openapi: "3.1.0",
  info: {
    title: "payment-api",
    version: "4.0.1"
  },
  paths: {
    "/payment/payment_methods": {
      get: {
        tags: ["payment"],
        summary: "Payment Methods Get",
        operationId: "payment_payment_methods_get",
        parameters: [{
          name: "country_code",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Country Code"
          }
        }, {
          name: "language_code",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            "default": "en",
            title: "Language Code"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/payment/order": {
      post: {
        tags: ["payment_order"],
        summary: "Router Payment Order Post",
        operationId: "payment_order_post",
        parameters: [{
          name: "selling_platform_id",
          "in": "query",
          required: false,
          schema: {
            type: "integer",
            "default": 7,
            title: "Selling Platform Id"
          }
        }, {
          name: "fulfillment_channel_id",
          "in": "query",
          required: false,
          schema: {
            type: "integer",
            "default": 1,
            title: "Fulfillment Channel Id"
          }
        }, {
          name: "payment_provider",
          "in": "query",
          required: false,
          schema: {
            "enum": ["LSOFT", "MOLLIE", "AMAZON", "BANK", "PAYPAL", "RAKUTEN_FR", "SAFERPAY"],
            type: "string",
            "default": "MOLLIE",
            title: "Payment Provider"
          }
        }, {
          name: "redirect_url",
          "in": "query",
          required: false,
          schema: {
            type: "string",
            title: "Redirect Url"
          }
        }],
        requestBody: {
          required: true,
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/TPaymentOrderData-Input"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/TPaymentOrderData-Output"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/payment/order/{order_number}": {
      patch: {
        tags: ["payment_order"],
        summary: "Router Payment Order Patch",
        operationId: "payment_order__order_number__patch",
        parameters: [{
          name: "order_number",
          "in": "path",
          required: true,
          schema: {
            type: "string",
            title: "Order Number"
          }
        }, {
          name: "selling_platform_id",
          "in": "query",
          required: false,
          schema: {
            type: "integer",
            "default": 7,
            title: "Selling Platform Id"
          }
        }, {
          name: "fulfillment_channel_id",
          "in": "query",
          required: false,
          schema: {
            type: "integer",
            "default": 1,
            title: "Fulfillment Channel Id"
          }
        }, {
          name: "payment_provider",
          "in": "query",
          required: false,
          schema: {
            "enum": ["LSOFT", "MOLLIE", "AMAZON", "BANK", "PAYPAL", "RAKUTEN_FR", "SAFERPAY"],
            type: "string",
            "default": "MOLLIE",
            title: "Payment Provider"
          }
        }, {
          name: "redirect_url",
          "in": "query",
          required: false,
          schema: {
            type: "string",
            title: "Redirect Url"
          }
        }, {
          name: "update_mollie",
          "in": "query",
          required: false,
          schema: {
            type: "boolean",
            "default": false,
            title: "Update Mollie"
          }
        }],
        requestBody: {
          required: true,
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/TPaymentOrderData-Input"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/TPaymentOrderData-Output"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      get: {
        tags: ["payment_order"],
        summary: "Router Payment Order Get",
        operationId: "payment_order__order_number__get",
        parameters: [{
          name: "order_number",
          "in": "path",
          required: true,
          schema: {
            type: "string",
            title: "Order Number"
          }
        }, {
          name: "provider_check",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            "default": false,
            title: "Provider Check"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/TPaymentOrder"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/payment/order/{order_number}/checkout_link": {
      get: {
        tags: ["payment_order"],
        summary: "Router Payment Order Checkout Link Get",
        operationId: "payment_order__order_number__checkout_link_get",
        parameters: [{
          name: "order_number",
          "in": "path",
          required: true,
          schema: {
            type: "string",
            title: "Order Number"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/CheckoutLink"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/payment/order/provider_id/{id}": {
      get: {
        tags: ["payment_order"],
        summary: "Router Payment Order Provider Id",
        operationId: "payment_order_provider_id__id__get",
        parameters: [{
          name: "id",
          "in": "path",
          required: true,
          schema: {
            type: "string",
            title: "Id"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/payment/provider/order/{id}": {
      get: {
        tags: ["payment_provider"],
        summary: "Payment Provider Order Provider Id",
        operationId: "payment_provider_order__id__get",
        parameters: [{
          name: "id",
          "in": "path",
          required: true,
          schema: {
            type: "string",
            title: "Id"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/healthz": {
      get: {
        summary: "Healthz Get",
        operationId: "healthz_get_healthz_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    }
  },
  components: {
    schemas: {
      CheckoutLink: {
        properties: {
          orderNumber: {
            type: "string",
            title: "Ordernumber"
          },
          checkoutLink: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Checkoutlink"
          }
        },
        type: "object",
        required: ["orderNumber"],
        title: "CheckoutLink"
      },
      HTTPValidationError: {
        properties: {
          detail: {
            items: {
              $ref: "#/components/schemas/ValidationError"
            },
            type: "array",
            title: "Detail"
          }
        },
        type: "object",
        title: "HTTPValidationError"
      },
      TAddress: {
        properties: {
          title: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Title"
          },
          givenName: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Givenname"
          },
          familyName: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Familyname"
          },
          organizationName: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Organizationname"
          },
          streetAndNumber: {
            type: "string",
            title: "Streetandnumber"
          },
          streetAdditional: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Streetadditional"
          },
          postalCode: {
            type: "string",
            title: "Postalcode"
          },
          email: {
            type: "string",
            title: "Email"
          },
          phone: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Phone"
          },
          city: {
            type: "string",
            title: "City"
          },
          region: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Region"
          },
          country: {
            type: "string",
            title: "Country"
          }
        },
        type: "object",
        required: ["streetAndNumber", "postalCode", "email", "city", "country"],
        title: "TAddress"
      },
      TAmount: {
        properties: {
          currency: {
            type: "string",
            title: "Currency"
          },
          value: {
            type: "string",
            title: "Value"
          }
        },
        type: "object",
        required: ["currency", "value"],
        title: "TAmount"
      },
      TLink: {
        properties: {
          href: {
            type: "string",
            title: "Href"
          },
          type: {
            type: "string",
            title: "Type"
          }
        },
        type: "object",
        required: ["href", "type"],
        title: "TLink"
      },
      TPayment: {
        properties: {
          method: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Method"
          },
          amount: {
            $ref: "#/components/schemas/TAmount"
          },
          status: {
            type: "string",
            title: "Status"
          },
          id: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Id"
          },
          paidAt: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Paidat"
          },
          authorizedAt: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Authorizedat"
          },
          mode: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Mode"
          },
          details: {
            anyOf: [{
              type: "object"
            }, {
              type: "null"
            }],
            title: "Details"
          },
          _links: {
            additionalProperties: {
              $ref: "#/components/schemas/TLink"
            },
            type: "object",
            title: " Links"
          },
          provider: {
            type: "string",
            title: "Provider"
          }
        },
        type: "object",
        required: ["amount", "status", "provider"],
        title: "TPayment"
      },
      TPaymentOrder: {
        properties: {
          ORDER_NUMBER: {
            type: "string",
            title: "Order Number"
          },
          VERSION: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Version"
          },
          DATA: {
            $ref: "#/components/schemas/TPaymentOrderData-Output"
          },
          EMAIL: {
            type: "string",
            title: "Email"
          },
          TYPE: {
            type: "string",
            title: "Type",
            "default": "ORDER"
          },
          selling_platform_id: {
            type: "integer",
            title: "Selling Platform Id",
            "default": 7
          },
          fulfillment_channel_id: {
            type: "integer",
            title: "Fulfillment Channel Id",
            "default": 1
          },
          payment_provider: {
            type: "string",
            "enum": ["LSOFT", "MOLLIE", "AMAZON", "BANK", "PAYPAL", "RAKUTEN_FR", "SAFERPAY"],
            title: "Payment Provider",
            "default": "MOLLIE"
          }
        },
        type: "object",
        required: ["ORDER_NUMBER", "DATA", "EMAIL"],
        title: "TPaymentOrder"
      },
      "TPaymentOrderData-Input": {
        properties: {
          locale: {
            type: "string",
            title: "Locale"
          },
          orderNumber: {
            type: "string",
            title: "Ordernumber"
          },
          id: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Id"
          },
          amount: {
            $ref: "#/components/schemas/TAmount"
          },
          billingAddress: {
            $ref: "#/components/schemas/TAddress"
          },
          shippingAddress: {
            $ref: "#/components/schemas/TAddress"
          },
          redirectUrl: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Redirecturl"
          },
          webhookUrl: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Webhookurl"
          },
          cancelUrl: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Cancelurl"
          },
          _links: {
            additionalProperties: {
              $ref: "#/components/schemas/TLink"
            },
            type: "object",
            title: " Links"
          },
          _embedded: {
            additionalProperties: {
              items: {
                $ref: "#/components/schemas/TPayment"
              },
              type: "array"
            },
            type: "object",
            title: " Embedded"
          },
          createdAt: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Createdat"
          }
        },
        additionalProperties: true,
        type: "object",
        required: ["locale", "orderNumber", "amount", "billingAddress", "shippingAddress"],
        title: "TPaymentOrderData"
      },
      "TPaymentOrderData-Output": {
        properties: {
          locale: {
            type: "string",
            title: "Locale"
          },
          orderNumber: {
            type: "string",
            title: "Ordernumber"
          },
          id: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Id"
          },
          amount: {
            $ref: "#/components/schemas/TAmount"
          },
          billingAddress: {
            $ref: "#/components/schemas/TAddress"
          },
          shippingAddress: {
            $ref: "#/components/schemas/TAddress"
          },
          redirectUrl: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Redirecturl"
          },
          webhookUrl: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Webhookurl"
          },
          cancelUrl: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Cancelurl"
          },
          _links: {
            additionalProperties: {
              $ref: "#/components/schemas/TLink"
            },
            type: "object",
            title: " Links"
          },
          _embedded: {
            additionalProperties: {
              items: {
                $ref: "#/components/schemas/TPayment"
              },
              type: "array"
            },
            type: "object",
            title: " Embedded"
          },
          createdAt: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Createdat"
          }
        },
        additionalProperties: true,
        type: "object",
        required: ["locale", "orderNumber", "amount", "billingAddress", "shippingAddress"],
        title: "TPaymentOrderData"
      },
      ValidationError: {
        properties: {
          loc: {
            items: {
              anyOf: [{
                type: "string"
              }, {
                type: "integer"
              }]
            },
            type: "array",
            title: "Location"
          },
          msg: {
            type: "string",
            title: "Message"
          },
          type: {
            type: "string",
            title: "Error Type"
          }
        },
        type: "object",
        required: ["loc", "msg", "type"],
        title: "ValidationError"
      }
    }
  }
};
var payment_api = exports.payment_api = (0, _lsfastapiClient.Api)(openapi);
//# sourceMappingURL=index.js.map